import {render} from "react-dom";
import React from "react";

document.addEventListener('DOMContentLoaded', () => {
    const cartNodes = Array.from(document.querySelectorAll('[data-product-cart]'));
    if (cartNodes.length) {
        import(/* webpackChunkName: "Cart" */ './components/Cart').then(({ default: Cart }) => {
            cartNodes.forEach((node) => {
                const shopwareUrl = node.dataset.shopwareUrl;
                const vehicleMeta = JSON.parse(node.dataset.vehicleMeta || '{}');
                const montagePlannerFlowUrl = node.dataset.montagePlannerFlowUrl;
                const shopOverviewUrl = node.dataset.shopOverviewUrl;
                const shopHomeUrl = node.dataset.shopHomeUrl;

                render(
                    <Cart
                        shopwareUrl={shopwareUrl}
                        vehicleMeta={vehicleMeta}
                        montagePlannerFlowUrl={montagePlannerFlowUrl}
                        shopOverviewUrl={shopOverviewUrl}
                        shopHomeUrl={shopHomeUrl}
                    />,
                    node
                );
            });
        });
    }
});
